import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Sparkles, User, Loader2, ArrowRight } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { Markdown } from '../components/Markdown';
import { Button } from '../components/ui/button';
import { api } from '../lib/api';

const Shared = () => {
  const { t, lang } = useApp();
  const { shareId } = useParams();
  const [conv, setConv] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => { api.getShared(shareId).then(setConv).catch(() => setError(true)); }, [shareId]);

  return (
    <div className="min-h-screen bg-background" data-testid="shared-page">
      <header className="h-16 border-b border-border flex items-center justify-between px-5 sm:px-8 sticky top-0 bg-background/80 backdrop-blur z-10">
        <Link to="/" className="flex items-center gap-2"><span className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center"><Sparkles className="h-4 w-4 text-primary-foreground" /></span><span className="font-display text-lg font-bold">Aurra<span className="text-primary">.</span></span></Link>
        <Button asChild size="sm" className="rounded-lg font-semibold gap-1.5"><Link to="/login?mode=register" data-testid="shared-cta">{t.share.cta} <ArrowRight className="h-3.5 w-3.5" /></Link></Button>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        {error ? (
          <div className="text-center py-20" data-testid="shared-not-found"><h1 className="font-display text-2xl font-bold">{t.share.notFound}</h1><p className="mt-2 text-muted-foreground">{t.share.notFoundSub}</p></div>
        ) : !conv ? <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div> : (
          <>
            <div className="mb-8">
              <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{t.share.sharedLabel}</p>
              <h1 className="mt-1 font-display text-2xl sm:text-3xl font-bold" data-testid="shared-title">{conv.title}</h1>
              <p className="mt-1 text-sm text-muted-foreground">{new Date(conv.created_at).toLocaleDateString(lang === 'fr' ? 'fr-FR' : 'en-US', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
            </div>
            <div className="space-y-6">
              {conv.messages.map((m, i) => (
                <div key={m.id ?? `${m.role}-${i}`} data-testid={`shared-message-${m.role}`} className={`flex gap-3.5 ${m.role === 'user' ? 'justify-end' : ''}`}>
                  {m.role === 'assistant' && <span className="h-8 w-8 shrink-0 rounded-lg bg-primary flex items-center justify-center"><Sparkles className="h-4 w-4 text-primary-foreground" /></span>}
                  <div className={`max-w-[85%] min-w-0 rounded-2xl px-4 py-3 text-sm leading-relaxed ${m.role === 'user' ? 'order-1 bg-primary text-primary-foreground rounded-tr-sm whitespace-pre-wrap' : 'bg-secondary rounded-tl-sm'}`}>
                    {m.role === 'assistant' ? <Markdown>{m.content}</Markdown> : m.content}
                  </div>
                  {m.role === 'user' && <span className="h-8 w-8 shrink-0 rounded-lg bg-secondary flex items-center justify-center"><User className="h-4 w-4" /></span>}
                </div>
              ))}
            </div>
          </>
        )}
      </main>
    </div>
  );
};

export default Shared;
